// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf, maybe } from "@altostra/type-validations";
import { string, nullValidation, number } from "@altostra/type-validations/lib/primitives";

export const isCompaniesCompanyIdCustomRolesCustomRoleIdResult = objectOf({
  custom_role: objectOf({
    id: string,
    name: string,
    permissions: arrayOf(
      objectOf({
        company_id: string,
        app_group_id: string,
        territory_id: anyOf(string, nullValidation),
        scope_id: string,
        scope: number,
        name: number,
      })
    ),
    permission_set_assignments: arrayOf(
      objectOf({
        agps_id: string,
        ag_id: string,
      })
    ),
    last_updated_at: string,
    number_of_app_groups: number,
    number_of_territories: number,
    number_of_assignee_developers: number,
    scim_groups: maybe(arrayOf(string)),
  }),
});
